module.exports = __webpack_public_path__ + "img/SketchPng833f2732ce0f0dcf0723f63f357df471b387dfb14125d93a7af6870e9fcf8fce.5bb25ecb.png";